import { Component, OnInit, Inject, Renderer2 } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { LocalStorageService } from '../../services/local-storage-service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { GibberishDetectorService } from '../../services/gibberish-detector';
import { GrammarCheckService } from '../../services/grammar-check.service';


import * as $ from 'jquery';

@Component({
    selector: 'app-textanalyzer',
    templateUrl: './textanalyzer.component.html',
    styleUrls: ['./textanalyzer.component.css']
})
export class TextanalyzerComponent implements OnInit {
    captchaResponse: string = '';
    public apiInputs = { "project_id": "", "supplier_id": "", "token": "", "ip_address": "", "form_data": "", "udid": "", "question_id": 0 };
    public feedbackSet: any = [];
    public feedbackQuestions: any = [];
    public currentIndex: number = 1;
    public totalQuestion: number = 7;
    public apiRequestStatus: boolean = false;
    public currentCustomer: any = {};
    public client: any = '';
    public store: any = '';
    public token: any = '';
    public logoimage = '';
    public clientlogo = '';
    public todate = new Date();
    public embeded_url: any = "";
    public is_boat: any;
    public nextques: any;
    public question_id: any;
    public gifcaptcha = '';
    public image_url=this.apiService.imageurl;
    public isGibberish = false;
    public projectid: any = '';
    public supplierid: any = '';




    constructor(
        public apiService: ApiService,
        public router: Router,
        private activatedRoute: ActivatedRoute,
        private localStorageService: LocalStorageService,
        public sanitized: DomSanitizer,
        private gibberishDetector: GibberishDetectorService,
        private grammarService: GrammarCheckService


    ) {
        this.activatedRoute.queryParams.subscribe((params: Params) => {


            if (typeof params.projectid != 'undefined' && params.projectid != '' && params.projectid != null &&
                typeof params.supplierid != 'undefined' && params.supplierid != '' && params.supplierid != null
            ) {
                this.projectid = params.projectid;
                this.supplierid = params.supplierid;
                this.client = params.projectid;
                this.store = params.supplierid;
                this.token = params?.token;
                this.gifcaptcha = params?.gif_captcha;
                this.apiInputs.project_id = this.client;
                this.apiInputs.supplier_id = this.store;
                this.apiInputs.token = this.token;
                this.apiInputs.udid = params.udid;

            }
            else {
                // this.router.navigate(['survey/not-found']);
            }
        });

    }
    siteKey: string = "6LeNpgAsAAAAAEKVdIyZ9Btg8ZUlymP73udCVBiw";
    secretKey: string = "6LeNpgAsAAAAAEKVdIyZ9Btg8ZUlymP73udCVBiw";

    ngOnInit(): void {

        this.getCustomer();
        this.get_captcha_list();
            
        



    }
    handleCaptchaResponse(response: string): void {
        this.captchaResponse = response;
        console.log('this.captchaResponse', this.captchaResponse);
    }

    async getCustomer() {
        var currentCustomerTemp: any = await this.localStorageService.getItem("currentCustomer");
        this.currentCustomer = JSON.parse(currentCustomerTemp);
        console.log("this.currentCustomer", this.currentCustomer);
    }

    showLoader() {
        $("#loader_form").show();
    }

    hideLoader() {
        $("#loader_form").hide();
    }

    

    prev(index = 0) {
        console.log("prev pre", this.currentIndex)
        if (this.currentIndex > 1) {
            this.currentIndex -= 1;
            console.log("prev post", this.currentIndex)
        }
    }

    next(index = this.currentIndex) {
         if (typeof this.feedbackQuestions[(index - 1)]?.ans_data == 'undefined' ||
            this.feedbackQuestions[(index - 1)]?.ans_data == null ||
            this.feedbackQuestions[(index - 1)]?.ans_data == '') {
            this.apiService.showToast("This is required field.", 1000);
            return false;
        }

        console.log("next pre", this.currentIndex);
        if (this.currentIndex < this.totalQuestion) {
            this.currentIndex += 1;
        }
        console.log("next post", this.currentIndex);

        return true;
    }

    submit() {
       
        
        if (typeof this.feedbackQuestions[(this.currentIndex - 1)]?.ans_data == 'undefined' ||
            this.feedbackQuestions[(this.currentIndex - 1)]?.ans_data == null ||
            this.feedbackQuestions[(this.currentIndex - 1)]?.ans_data == '') {
            this.apiService.showToast("This is required field.", 2000);
            return false;
        }

        this.apiInputs.form_data = JSON.stringify(this.feedbackQuestions);
        var ansdata = this.feedbackQuestions[(this.currentIndex - 1)]?.ans_data;
       
       

        this.showLoader();
        
            this.apiService.postApi(this.apiInputs, 'user/submit_textanalyzer').subscribe((result) => {
                this.hideLoader();
                var result = JSON.parse(this.apiService.decode(result.successdata));
                this.gifcaptcha = 'no';
                if (result.status == 1 && result.prescan != 1) {
                    decodeURI(result.url);
                    window.location = result.url;
                } else if (result.status == 11 && result.prescan != 1) {
                    decodeURI(result.url);
                    this.embeded_url = this.sanitized.bypassSecurityTrustResourceUrl(result.url);
                } else {
                    if (
                        typeof this.projectid != 'undefined' && this.projectid != null && this.projectid != '' &&
                        typeof this.supplierid != 'undefined' && this.supplierid != null && this.supplierid != ''
        
                    ) {
                        this.router.navigate(
                            ['survey/survey'],
                            { queryParams: { projectid: this.projectid, supplierid: this.supplierid, token: this.token, gif_captcha: 'no' } }
                        );
                    }
                }
            }, (err) => {
    
                console.log("user/getProjectQuestion", JSON.stringify(err));
            });   
        

    }

    parseInt(val: any): number {
        return parseInt(val) || 0;
    }

    setAnswer(_this: any, index = 0, value: any, extra = null) {
        this.feedbackQuestions[index].ans_data = value;
        console.log("answerSetsTemp[index]->" + index, this.feedbackQuestions[index]);
    }

    setMultiAnswer(_this: any, index = 0, value: any, extra = null) {
        this.feedbackQuestions[index].ans_data = value;
        console.log("answerSetsTemp[index]->" + index, this.feedbackQuestions[index]);
    }

    isNumber(value: any): boolean {
        console.log(value);
        return typeof value === 'number' && !isNaN(value);
    }

    get_captcha_list(data = 0) {

        this.showLoader();
        if (data != 0) {
            this.apiInputs.question_id = data;
        }

        this.apiService.postApi(this.apiInputs, 'user/getTextAnalyzerQuestion').subscribe((result) => {
            this.hideLoader();
            var result = JSON.parse(this.apiService.decode(result.successdata));
            if (result.status) {
                this.apiRequestStatus = true;
                console.log('feedback_list result', result);

                //this.feedbackSet = result?.data?.feedback_set;
                this.feedbackQuestions = result?.data;
                this.totalQuestion = this.feedbackQuestions.length;
                console.log('this.totalQuestion',this.totalQuestion);
                this.is_boat = result.is_boat;
                // this.logoimage  = result.client_logo;
                //this.clientlogo = this.apiService.clientlogourl;

            }
            else {
                this.router.navigate(['survey/not-found']);
            }

        }, (err) => {
            this.hideLoader();
            this.router.navigate(['not-found']);
            console.log("user/getProjectQuestion", JSON.stringify(err));
        });
    }

   

      
}
